import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ApiError extends EluveError {
  static override readonly errorName = 'ApiError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'API request failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
